import Routes from 'routes/index'
import React, { Suspense, useEffect } from 'react'
import Loader from 'components/ui-kit/Loader/index'
import { removeAuthTokenFromSessionStorage } from 'utils/common-services/sessionStorage.service'

function App () {
  useEffect(() => {
    removeAuthTokenFromSessionStorage()
  }, [])

  return (
    <Suspense fallback={<Loader />}>
      <Routes />
    </Suspense>
  )
}

export default App
